import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import Content from "../../../components/layout/Content";
import { useDispatch, useSelector } from "react-redux";
import { fetchInvoices, fetchInvoicesExport, fetchSuppliers } from "../../../action";
import InvoiceList from "./InvoiceList";
import ErrorContainer from "../../../components/utils/ErrorContainer";
import HeadMobileActionMenu from "../../../components/utils/HeadMobileActionMenu";
import { fetchFilials } from '../../../action/handbook';
import { isEmpty } from 'lodash';
import swal from 'sweetalert';
import { fetchSettings } from '../../../action/app';
import { parseNumToFixed } from '../../../utils/common';
import { utils, writeFileXLSX } from 'xlsx';
import { formatDateTime } from '../../../utils/formatDateTime';
import { suppliersSelector } from '../../../selectors/forms';
import moment from 'moment';

const Invoice = ({ history }) => {
    const dispatch = useDispatch();
    const settings = useSelector(state => state.settings.init);
    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const pointsLoading = useSelector(state => state.loaders.filials);
    const suppliers = useSelector(suppliersSelector);
    const filters = useSelector(state => state.invoiceforms.filters);

    const onRefresh = () => {
        dispatch(fetchInvoices());
        dispatch(fetchFilials());
        dispatch(fetchSuppliers(false, true));
        dispatch(fetchSettings());
    };

    useEffect(() => {
        if (isEmpty(settings)) dispatch(fetchSettings());
        if (isEmpty(points) || points.length < pointsCount) dispatch(fetchFilials(null, true));
        if (isEmpty(suppliers)) dispatch(fetchSuppliers(false, true));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [settings, dispatch]);

    const openForm = () => {
        if (!isEmpty(settings) && !settings.enableConsumption) {
            return swal({
                title: 'Создание накладной невозможно',
                text: '"Списание сырья" отключено',
                icon: "error",
                dangerMode: true,
                button: "Ок",
            });
        } else {
            history.push('/accounting/invoice/form');
        }
    }

    const actionsMobile = [
        { name: 'Добавить накладную', icon: 'flaticon2-plus', action: () => openForm() },
    ];

    const onExport = async () => {
        const data = await dispatch(fetchInvoicesExport());
        if (!data || data.length === 0) return swal({
            title: 'Ошибка экспорта',
            text: 'Данные не найдены',
            icon: "error",
            dangerMode: true,
            button: "Ок",
        });

        const totalSum = () => {
            const total = data.reduce((acc, item) => {
                return acc + (parseNumToFixed(item.totalSum) || 0);
            }, 0);
            return parseNumToFixed(total);
        };

        const renderAdress = (point) => {
            if (!point) return 'Адрес не указан';
            const cityName = point.city ? point.city.name : 'Город не указан';
            const street = point.street ? point.street : 'Улица не указана';
            const house = point.house ? point.house : '';
            
            return `${cityName}, ${street} ${house}`;
        };

        const getPayment = (item) => {
            if (!item.payment || item.payment === 'none') return 'Не оплачено';
            return `Оплачено ${item.payment === 'cash' ? 'Наличные' : 'Расчетный счет'}`;
        }

        const exportData = data.map((item) => {
            let point = item.point;
            if (point && !point.id) point = points.find((el) => el.id === point);
            if (point && point.id && (!point.city || !point.city.id)) point = points.find((el) => el.id === point.id);
            item.point = point;
            if (item.supplier && !item.supplier.id) item.supplier = suppliers.find((supplier) => supplier.id === item.supplier);
                return ({
                '№': item.number || item.id,
                'Дата': formatDateTime(item.date),
                'Поставщик': item.supplier && item.supplier.name ? item.supplier.name : "Не указан",
                'Филиал': renderAdress(item.point),
                'Примечание': item.note || '',
                'Оплата': getPayment(item),
                'Сумма': parseNumToFixed(item.totalSum) || 0,
                'Дата оплаты': item.paymented_at ? moment(item.paymented_at).format('DD.MM.YYYY HH:mm') : '-',
            })
        });

        exportData.push({
            'Дата': 'Итого',
            'Сумма': totalSum(),
        });

        const startDate = filters.startDate ? moment(filters.startDate).format('DD.MM.YYYY') : moment().endOf('day').toDate().format('DD.MM.YYYY');
        const endDate = filters.endDate ? moment(filters.endDate).format('DD.MM.YYYY') : moment().startOf('day').toDate().format('DD.MM.YYYY');

        const ws = utils.json_to_sheet(exportData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Накладные');
        writeFileXLSX(wb, `Накладные ${startDate}-${endDate}.xlsx`);
    }

    const renderSubHeader = () => {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container kt-container--fluid">
                    <div className="kt-subheader__main">
                        <h3 className="kt-subheader__title">Накладные</h3>
                    </div>
                    <div className="kt-subheader__toolbar">
                        <button disabled={pointsLoading} onClick={onExport} className='btn btn-dark btn-icon-sm'>
                            Экспорт
                        </button>
                        {window.innerWidth > 1024 && (
                            <button
                                className="btn btn-success btn-icon-sm"
                                onClick={openForm}>
                                Добавить накладную
                            </button>
                        )}
                        <button onClick={onRefresh} className="btn btn-secondary btn-icon">
                            <i className="la la-refresh"></i>
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Content>
            {renderSubHeader()}
            <HeadMobileActionMenu actions={actionsMobile} />
            <ErrorContainer field='invoiceForms' hasCloseButton={true} style={{ margin: 25 }}/>
            <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
                <div className="kt-grid kt-grid--desktop kt-grid--ver-desktop kt-todo">
                    <div className="kt-grid__item kt-grid__item--fluid kt-todo__content">
                        <InvoiceList />
                    </div>
                </div>
            </div>
        </Content>
    );
};

export default withRouter(Invoice);
